<rl-edit-form [formType]="data.type" [item]="data.item" [type]="'edit'" (onCancel)="exit()" (onClose)="exit()"></rl-edit-form>